import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getOtherMaterialReturnDetail } from '../api/index.js';
export default {
  name: 'MaterialReturnViewDrawer',
  props: {
    id: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {
      loading: false,
      form: {
        refund_user_name: '',
        refund_date: '',
        organize_name: '',
        updated_user_name: '',
        remark: ''
      },
      dataList: [],
      pages: {
        page: 1,
        pagesize: 20,
        totalCount: 0
      }
    };
  },
  created: function created() {
    this.getDetail();
  },
  methods: {
    getDetail: function getDetail() {
      var _this = this;
      this.loading = true;
      getOtherMaterialReturnDetail({
        id: this.id
      }).then(function (res) {
        // TODO: 根据实际接口返回结构赋值
        var info = res.data.user_info;
        _this.form.user_name = info.user_name || '';
        _this.form.date = info.date || '';
        _this.form.remark = info.remark || '';
        _this.dataList = res.data.list;
      }).finally(function () {
        _this.loading = false;
      });
    },
    currentChange: function currentChange(val) {
      this.pages.page = val;
      this.getDetail();
    },
    sizeChange: function sizeChange(val) {
      this.pages.pagesize = val;
      this.pages.page = 1;
      this.getDetail();
    },
    handleClose: function handleClose() {
      this.$emit('close');
    }
  }
};